import { render, staticRenderFns } from "./DIV.vue?vue&type=template&id=59d8a260"
import script from "./DIV.vue?vue&type=script&lang=js"
export * from "./DIV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports